export const SEND_USER_INFO = "SEND_USER_INFO";
export const PUT_USER_INFO = "PUT_USER_INFO";
export const PUT_USER_OCTAVOS = "PUT_USER_OCTAVOS";
export const PUT_USER_RESULT = "PUT_USER_RESULT";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_USERS_RANKING = "GET_USERS_RANKING";
export const GET_ALL_USERS_RANKING = "GET_ALL_USERS_RANKING";
export const GET_TOP_FIVE = "GET_TOP_FIVE";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO2 = "GET_USER_INFO2";
export const PUT_GAME_LOCAL_TEAM = "PUT_GAME_LOCAL_TEAM";
export const PUT_GAME_AWAY_TEAM = "PUT_GAME_AWAY_TEAM";
export const PUT_GAME_RESULT = "PUT_GAME_RESULT";
export const GET_ALL_GAMES = "GET_ALL_GAMES";
export const GET_ID_GAME = "GET_ID_GAME";
export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const GET_ID_TEAM = "GET_ID_TEAM";
export const GET_GROUP_TEAMS = "GET_GROUP_TEAMS";
export const PUT_ID_TEAM = "PUT_ID_TEAM";
export const GET_GROUP_GAMES = "GET_GROUP_GAMES";
export const PUT_GAME_PENALTIES = "PUT_GAME_PENALTIES";
export const GET_WORLD_CUP = "GET_WORLD_CUP";
export const PUT_CHAMPION = "PUT_CHAMPION";
export const PUT_SECOND = "PUT_SECOND";
export const PUT_THIRD = "PUT_THIRD";
export const PUT_BEST_PLAYER = "PUT_BEST_PLAYER";
export const PUT_OCTAVOS_TEAM = "PUT_OCTAVOS_TEAM";
export const TOGGLE_DARKMODE = "TOGGLE_DARKMODE";
export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
export const GET_SEARCH_USERS = "GET_SEARCH_USERS";
export const GET_ALL_USERS_NOADMIN = " GET_ALL_USERS_NOADMIN";
export const CLEAN_GAMES = " CLEAN_GAMES";
export const CLEAN_TEAMS = " CLEAN_TEAMS";
export const RESET_GAMES = " RESET_GAMES";


